<!-- <div class="w-full">
  <div class="relative">
    <input type="text" [value]="searchText" (click)="triggerSearchOnClick()"
      (focus)="triggerSearchOnClick()" (input)="onInputChange($any($event.target).value)" (keydown)="onKeyDown($event)"
      autocomplete="off" class="kt-input kt-input-sm "
      [disabled]="disabled"
      [placeholder]="disabled ? getDependencyMessage() : placeholder" />


    <div *ngIf="isLoading" class="absolute right-3 top-1/2 -translate-y-1/2">
      <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"></div>
    </div>

    <div *ngIf="isOpen"
      class="absolute z-50 mt-1 w-full overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg">
      <ul class="max-h-60 overflow-auto py-1 text-sm">
        <li *ngFor="let item of items; let i = index; trackBy: trackByFn" (click)="selectItem(item)"
          class="cursor-pointer px-3 py-2 hover:bg-blue-50 hover:text-blue-700"
          [ngClass]="{ 'bg-blue-100 text-blue-700': i === activeIndex }">
          {{ item[labelField] }}
        </li>

        <li *ngIf="!isLoading && items.length === 0" class="px-3 py-2 text-gray-500 text-xs">
          No results found
        </li>
      </ul>
    </div>
  </div>
</div> -->
<!-- 
<div class="w-full">
  <div class="relative group">
    <input type="text" [value]="searchText" (click)="handleInteraction()"
      (focus)="!isAdvancedMode && triggerSearchOnClick()"
      (input)="!isAdvancedMode && onInputChange($any($event.target).value)"
      (keydown)="!isAdvancedMode && onKeyDown($event)" [readonly]="isAdvancedMode" autocomplete="off"
      class="kt-input kt-input-sm w-full pr-10" [ngClass]="{'cursor-pointer bg-slate-50': isAdvancedMode}"
      [disabled]="disabled" [placeholder]="disabled ? getDependencyMessage() : placeholder" />

    <div *ngIf="isAdvancedMode && !isLoading" (click)="handleInteraction()"
      class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-slate-400 hover:text-blue-600 transition-colors">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.3-4.3"></path>
      </svg>
    </div>

    <div *ngIf="isLoading" class="absolute right-3 top-1/2 -translate-y-1/2">
      <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"></div>
    </div>

    <div *ngIf="isOpen && !isAdvancedMode"
      class="absolute z-50 mt-1 w-full overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg">
      <ul class="max-h-60 overflow-auto py-1 text-sm">
        <li *ngFor="let item of items; let i = index; trackBy: trackByFn" (click)="selectItem(item)"
          class="cursor-pointer px-3 py-2 hover:bg-blue-50 hover:text-blue-700"
          [ngClass]="{ 'bg-blue-100 text-blue-700': i === activeIndex }">
          {{ item[labelField] }}
        </li>

        <li *ngIf="!isLoading && items.length === 0" class="px-3 py-2 text-gray-500 text-xs">
          No results found
        </li>
      </ul>
    </div>
  </div>
</div> -->


<div class="flex items-center gap-2 w-full">
  <div class="relative flex-grow group kt-input-group">
    <input 
      type="text" 
      [value]="searchText" 
      (click)="handleInputInteraction()"
      (focus)="triggerSearchOnClick()"
      (input)="onInputChange($any($event.target).value)"
      (keydown)="onKeyDown($event)" 
      [readonly]="false" 
      autocomplete="off"
      class="kt-input kt-input-sm w-full"
      [ngClass]="{
        'bg-slate-50': disabled,
        'pr-10': isLoading
      }"
      [disabled]="disabled" 
      [placeholder]="disabled ? getDependencyMessage() : placeholder" 
    />

    <div *ngIf="isLoading" 
      class="absolute right-3 top-1/2 -translate-y-1/2 z-1"
      [ngClass]="{
      'z-1 right-32': isAdvancedMode,
      'right-3': !isAdvancedMode
      }">
      <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-blue-600"></div>
    </div>

      <span 
      *ngIf="isAdvancedMode"
      (click)="handleFilterClick()" 
      title="Advanced Search"
      class="hover:text-primary kt-input-addon kt-input-addon-icon kt-input-addon-sm">
              <i class="ki-filled ki-magnifier">
              </i>
              </span>

    <div *ngIf="isOpen"
      class="absolute z-50 mt-1 w-full overflow-hidden rounded-md border border-gray-200 bg-white shadow-lg mt-7">
      <ul class="max-h-60 overflow-auto py-1 text-sm">
        <li *ngFor="let item of items; let i = index; trackBy: trackByFn" 
          (click)="selectItem(item)"
          class="cursor-pointer px-3 py-2 hover:bg-blue-50 hover:text-blue-700 transition-colors"
          [ngClass]="{ 'bg-blue-100 text-blue-700': i === activeIndex }">
          {{ item[labelField] }}
        </li>

        <li *ngIf="!isLoading && items.length === 0" class="px-3 py-2 text-gray-500 text-xs italic">
          No results found
        </li>
      </ul>
    </div>
  </div>

  <!-- <button 
    *ngIf="isAdvancedMode" 
    type="button"
    (click)="handleFilterClick()"
    [disabled]="disabled"
    class="flex-shrink-0 flex items-center justify-center h-[32px] w-[32px] rounded border border-gray-300 bg-white text-slate-400 hover:text-blue-600 hover:border-blue-400 hover:bg-blue-50 transition-all shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
    title="Advanced Search">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="11" cy="11" r="8"></circle>
      <path d="m21 21-4.3-4.3"></path>
    </svg>
  </button> -->
</div>